import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';
import { createUseStyles } from 'react-jss';

const ButtonInput = (props) => {
  const { groupName, value, label, active, wrapperStyle, labelStyle, } = props;
  const { role = 'group', } = props;
  const styles = useStyles({ active, wrapperStyle, labelStyle, });
  const hasDriveTypeErrors = false;

  return (
    <div className={styles.wrapper} role={role} key={value}>
      <Field id={value} name={groupName} component="input" type="radio" value={value} style={{ display: 'none', }} />
      <span id={groupName} />
      <label
        style={hasDriveTypeErrors ? { margin: 0, color: '#ec8282', } : { margin: 0, }}
        htmlFor={value}
        className={styles.label}
      >
        <span style={hasDriveTypeErrors ? { color: '#ec8282', } : {}}>{label}</span>
      </label>
    </div>
  );
};

const useStyles = createUseStyles({
  wrapper: (props) => ({
    ...props.wrapperStyle,
  }),
  label: (props) => ({
    padding: 16,
    border: `2px solid ${props.active ? '#57c2f0' : '#d6d2d8'}`,
    borderRadius: 4,
    transition: 'all 0.2s',
    cursor: 'pointer',
    ...props.labelStyle,
  }),
});

ButtonInput.propTypes = {
  groupName: PropTypes.string.isRequired,
  role: PropTypes.string,
  active: PropTypes.bool,
  labelStyle: PropTypes.object,
  wrapperStyle: PropTypes.object,
  value: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
};

ButtonInput.defaultProps = {
  role: '',
  active: false,
  wrapperStyle: {},
  labelStyle: {},
}

export default ButtonInput;
